module.exports = __webpack_public_path__ + "media/vectors/term-bg-6-799ae147.jpg";